import React from 'react';
import {
  InputTable,
  type InputTableCellParams,
  type InputTableRowParams,
  type RepeatRowsPayload
} from '@/components/custom/erp';
import { copyCellValue } from '@/lib/table-handlers';
import type { ThueRow } from '../hooks/useThueRows';
import { SelectedCellInfo } from '../../../hooks';
import { getDataTableColumns } from './columns';
import { FormMode } from '@/types/form';
import { useTaxRate } from '@/hooks';
import ActionBar from './ActionBar';

interface ThueTabProps {
  formMode: FormMode;
  rows: ThueRow[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: (params: InputTableRowParams<ThueRow>) => void;
  onCellClick?: (params: InputTableCellParams) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: unknown) => void;
  onRepeatForRows: (payload: RepeatRowsPayload<ThueRow>) => void;
}

export const ThueTab: React.FC<ThueTabProps> = ({
  formMode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onMoveRow,
  onCellValueChange,
  onRepeatForRows
}) => {
  const { taxRates } = useTaxRate();
  return (
    <InputTable
      rows={rows}
      autoHeight
      bottomSelector='[data-arito-bottom-bar]'
      onRowClick={onRowClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={getDataTableColumns(taxRates, onCellValueChange, formMode)}
      getRowId={row => row?.uuid || ''}
      enableContextMenu
      onCopyData={({ columnValue, columnField, columnValues }) => {
        copyCellValue({
          columnField,
          columnValue,
          columnValues,
          fallback: text => console.log('Copy data per column:', text)
        });
      }}
      onRepeatForRows={onRepeatForRows}
      actionButtons={
        <ActionBar
          formMode={formMode}
          handleAddRow={onAddRow}
          handleDeleteRow={onDeleteRow}
          handleCopyRow={onCopyRow}
          handleMoveRow={onMoveRow}
          handleExport={() => console.log('Export clicked')}
          handlePin={() => console.log('Pin clicked')}
        />
      }
    />
  );
};
